export default {
  setUser(state, payload) {
    state.user_settings = payload.user_settings;
    state.token = payload.token;
    state.userId = payload.userId;
    state.email = payload.email;
    state.school = payload.school;
    state.fname = payload.fname;
    state.lname = payload.lname;
    state.isLoggedIn = payload.token !== null && payload.token != '' ? true : false;
    state.prework = payload.prework;
    state.experiences = payload.experiences;
    state.settings = payload.settings;
    state.notifications = payload.notifications;
    state.available_experiences = payload.available_experiences;
    state.certificate_teachers = payload.certificate_teachers;
    state.ctWhsEnabled = payload.ctWhsEnabled;
  },
  setFname(state, payload) {
    state.fname = payload;
  },
  setLname(state, payload) {
    state.lname = payload;
  },
  setEmail(state, payload) {
    state.email = payload;
  },
  /***
   * PREWORK MUTATIONS
   */
  preworkSetWSCert(state, payload) {
    state.prework.workplace_safety_url = payload;
  },
  preworkRemoveWSCert(state) {
    state.prework.workplace_safety_url = false;
  },
  preworkRemoveWSCertOther(state, payload) {
    state.prework.workplace_safety_url_other = state.prework.workplace_safety_url_other.filter(
      function (item) {
        return item.name !== payload;
      },
    );
  },
  preworkAddOtherWSCert(state, payload) {
    if (state.prework.workplace_safety_url_other == null) {
      state.prework.workplace_safety_url_other = [];
    }
    state.prework.workplace_safety_url_other.push(payload);
  },
  preworkCompleteWPModule(state, payload) {
    state.prework.workplace_preparation_modules_completed[payload] = true;
  },
  preworkSetWPModule(state, payload) {
    if (!state.prework.workplace_preparation_modules) {
      state.prework.workplace_preparation_modules = [];
    }
    state.prework.workplace_preparation_modules[payload.id] = payload.data;
  },
  /****
   * END PREWORK MUTATIONS
   */

  /******
   * EXPERIENCES MUTATIONS
   */
  setActiveExperienceID(state, payload) {
    state.active_experience_id = payload;
  },
  completePreworkSection(state, payload) {
    const pw = Object.assign({}, state.prework);
    if (typeof pw !== 'undefined' && pw !== null) {
      if (payload.section !== null) pw[payload.section] = payload.data;
      if (payload.application_type !== null) pw.application_type = payload.application_type;
      pw.status[payload.status_section] = payload.data !== null ? true : false;
      pw.status.completed = pw.status.section_apply && pw.status.section_wp && pw.status.section_ws;
      state.prework = pw;
    }
  },
  removeActiveExperience(state) {
    const experiences = Array.from(state.experiences);
    let experiences_new = [];
    experiences.forEach((experience) => {
      if (!experience.active) {
        experiences_new.push(experience);
      }
    });
    state.experiences = experiences_new;
  },
  addExperience(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.push(payload);
    state.experiences = experiences;
  },
  modifyExperience(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.forEach((experience) => {
      if (experience.id == payload.id) {
        for (const [key, value] of Object.entries(payload.data)) {
          experience[key] = value;
        }
      }
    });
    state.experiences = experiences;
  },
  /*****
   * POSTWORK
   * payload: {
   *   id: student VJE id
   *   section: section to update in postwork
   *   data: object
   * }
   */
  updateExperiencePostwork(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.forEach((experience) => {
      if (experience.id == payload.student_vje_id) {
        experience.postwork = payload.data;
      }
    });
    state.experiences = experiences;
  },
  requestedCertificate(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.forEach((experience) => {
      if (experience.id == payload.id) {
        experience.postwork = payload.postwork;
        experience.completed_for_postwork = false;
        experience.certificate_data.certificate_status = 1;
        experience.certificate_data.certificate_status_text = 'Requested';
        experience.certificate_data.certificate_date_requested =
          payload.data.certificate_date_requested_formatted;
      }
    });
    state.experiences = experiences;
  },
  setIsRequestedCertificate(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.forEach((experience) => {
      if (experience.id == payload.id) {
        experience.certificate_data.is_certificate_requested = payload.is_certificate_requested;
      }
    });
    state.experiences = experiences;
  },
  /****
   * ACTIVITIES
   */

  updateExperienceActivity(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.forEach((experience) => {
      if (experience.id == payload.student_vje_id) {
        let activityFound = false;
        const student_activities = Array.from(experience.student_activities);
        student_activities.forEach((activity, id) => {
          if (activity.activity_id == payload.activity_id) {
            student_activities[id] = payload.data;
            activityFound = true;
          }
        });
        if (!activityFound) {
          student_activities.push(payload.data);
        }
        experience.student_activities = student_activities;
      }
    });
    state.experiences = experiences;
  },
  /****
   * Learning & Resources
   */

  updateExperienceLR(state, payload) {
    const experiences = Array.from(state.experiences);
    experiences.forEach((experience) => {
      if (experience.id == payload.student_vje_id) {
        if (experience.learningresources == null) {
          experience.learningresources = payload;
        } else {
          experience.learningresources.data = payload.data;
        }
      }
    });
    state.experiences = experiences;
  },
  /****
   *  NOTIFICATIONS
   */
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  addNotification(state, payload) {
    state.notifications.unshift(payload);
  },
  markNotificationsRead(state, numNotifications) {
    const notifications = Array.from(state.notifications);
    let numMarked = 0;
    notifications.forEach((notification) => {
      if (notification.is_read == 0 && numMarked < numNotifications) {
        notification.is_read = 1;
        numMarked++;
      }
    });
    state.notifications = notifications;
  },
  markNotificationRead(state, nID) {
    const notifications = Array.from(state.notifications);
    notifications.forEach((notification) => {
      if (notification.id == nID) {
        notification.is_read = 1;
      }
    });
    state.notifications = notifications;
  },
  deleteNotification(state, nID) {
    const notifications = Array.from(state.notifications);
    const notifications_new = [];
    notifications.forEach((notification) => {
      if (notification.id != nID) {
        notifications_new.push(notification);
      }
    });
    state.notifications = notifications_new;
  },
  deleteNotifications(state) {
    state.notifications = [];
  },
};
